import type {CambioDeExportacion} from '@cnc/contracts';
import {useState} from 'react';
import {tr} from '../i18n/idioma';
import {fechaHora} from '../utilidades/formato';

// Cuantos cambios se ven sin abrir "Ver todo" (Daniel, 8/10/2026: historial corto).
const VISIBLES = 5;
// Cuantos datos de un cambio se leen en su linea antes de "+N".
const DATOS_EN_LINEA = 3;

// Historial de cambios de una exportacion, resumido: una linea por cambio
// (cuando, quien u origen, y los datos antes → despues); clic abre el detalle.
export function HistorialDeCambios({
  cambios,
  origenes,
}: {
  cambios: CambioDeExportacion[];
  origenes: Record<string, string>;
}) {
  const [todos, setTodos] = useState(false);
  const [abierto, setAbierto] = useState<number | null>(null);
  if (!cambios.length)
    return (
      <p className="text-sm text-apagado">{tr('Sin cambios hechos desde la app.', 'No changes made in the app.')}</p>
    );
  const lista = todos ? cambios : cambios.slice(0, VISIBLES);
  return (
    <div className="text-sm" data-prueba="historial-de-cambios">
      <ul className="divide-y divide-linea/70">
        {lista.map(c => {
          const resumen = c.campos
            .slice(0, DATOS_EN_LINEA)
            .map(x => `${x.etiqueta}: ${x.antes ?? '—'} → ${x.despues ?? '—'}`)
            .join(' · ');
          const mas = c.campos.length - DATOS_EN_LINEA;
          const quien = c.autor ?? origenes[c.origen] ?? c.origen;
          const expandido = abierto === c.id;
          return (
            <li key={c.id} className="py-1.5">
              <button
                type="button"
                onClick={() => setAbierto(expandido ? null : c.id)}
                aria-expanded={expandido}
                className="flex w-full items-baseline gap-2 text-left hover:text-verde-oscuro"
              >
                <span className="shrink-0 text-xs tabular-nums text-apagado">{fechaHora(c.fecha)}</span>
                <span className="shrink-0 text-xs font-medium">{quien}</span>
                <span className="min-w-0 truncate">
                  {resumen || tr('(sin datos)', '(no data)')}
                  {mas > 0 && <span className="text-apagado"> {tr(`+${mas} más`, `+${mas} more`)}</span>}
                </span>
              </button>
              {expandido && (
                <div className="mt-1 ml-2 space-y-0.5 border-l-2 border-linea pl-3 text-xs">
                  {c.autor && <div className="text-apagado">{origenes[c.origen] ?? c.origen}</div>}
                  {c.campos.map(x => (
                    <div key={x.campo} className="flex flex-wrap gap-1">
                      <span className="text-apagado">{x.etiqueta}:</span>
                      <span className="line-through decoration-alerta/60">{x.antes ?? '—'}</span>
                      <span aria-hidden>→</span>
                      <span className="font-medium">{x.despues ?? '—'}</span>
                    </div>
                  ))}
                </div>
              )}
            </li>
          );
        })}
      </ul>
      {cambios.length > VISIBLES && (
        <button type="button" onClick={() => setTodos(v => !v)} className="mt-2 text-xs text-verde hover:underline">
          {todos ? tr('Ver menos', 'Show less') : tr(`Ver todo (${cambios.length})`, `Show all (${cambios.length})`)}
        </button>
      )}
    </div>
  );
}
